export enum ChartType {
    VARIANCE = 'variance',
    TREND = 'trend',
    DETAIL = 'detail',
}
